// // pages/ProductDetails.tsx
// import React from "react";
// import ReviewCard from "../../Components/CardListing/ReviewCard";
// import { Avatar, Box, Card, CardContent, Rating, Stack, Typography } from "@mui/material";



// const reviews= [
//   {
//     id: 1,
//     name: "Lekha Ashokan",
//     rating: 4,
//     text:
//       "I'm thoroughly impressed with Deconstruct Sunscreen! It's the first sunscreen I've found that ticks every box. Its lightweight, non‑greasy formula is perfect for daily use, absorbing quickly without leaving residue or white cast. Suitable for all skin types, it leaves my skin feeling soft, smooth, sweat‑proof, and protected all day. The added benefit of plumpness is a lovely bonus! I'd highly recommend Deconstruct Sunscreen for its effectiveness, ease of use, and gentle formula.",
//     daysAgo: 3,
//     verified: true,
//     avatarUrl:"https://i.pravatar.cc/80?img=9",
//   },
//   {
//     id: 2,
//     name: "Lekha Ashokan",
//     rating: 2,
//     text:
//       "A most effective sunscreen in the market. Feels very lite, doesn't leave any white marks and is oil‑free. I am using this product for the last 6‑7 months and it is very useful!",
//     daysAgo: 3,
//     verified: true,
//         avatarUrl:"https://i.pravatar.cc/80?img=9",

//   },
//   {
//     id: 3,
//     name: "Lekha Ashokan",
//     rating: 4,
//     text:
//       "A most effective sunscreen in the market. Feels very lite, doesn't leave any white marks and is oil‑free. I am using this product for the last 6‑7 months and it is very useful!",
//     daysAgo: 3,
//     verified: true,
//         avatarUrl:"https://i.pravatar.cc/80?img=9",

//   },
//   {
//     id: 4,
//     name: "Lekha Ashokan",
//     rating: 4,
//     text:
//       "I'm thoroughly impressed with Deconstruct Sunscreen! It's the first sunscreen I've found that ticks every box. Its lightweight, non‑greasy formula is perfect for daily use, absorbing quickly without leaving residue or white cast. Suitable for all skin types, it leaves my skin feeling soft, smooth, sweat‑proof, and protected all day. The added benefit of plumpness is a lovely bonus! I'd highly recommend Deconstruct Sunscreen for its effectiveness, ease of use, and gentle formula.",
//     daysAgo: 3,
//     verified: true,
//         avatarUrl:"https://i.pravatar.cc/80?img=9",

//   },
// ];


// const ProductReview: React.FC<any> = React.memo ( (review)  => {
//   return (
//     <> 
//                 {reviews.map((review, index) => (

//     <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>

//       <CardContent>
//         {/* Rating & timestamp */}
//         <Stack direction="row" justifyContent="space-between" alignItems="center">
//           <Rating value={review.rating} precision={0.5} readOnly size="small" />
//           <Typography variant="caption" color="text.secondary">
//             {review.daysAgo} days ago
//           </Typography>
//         </Stack>

//         {/* Review text */}
//         <Typography variant="body2" mt={1} color="text.primary">
//           {review.text}
//         </Typography>

//         {/* Author */}
//         <Stack direction="row" spacing={2} mt={3} alignItems="center">
//           <Avatar src={review.avatarUrl} alt={review.name} sx={{ width: 48, height: 48 }} />

//           <Box>
//             <Typography variant="subtitle2" fontWeight={600}>
//               {review.name}
//             </Typography>

//             {review.verified && (
//               <Stack direction="row" spacing={0.5} alignItems="center">
//                 <Typography variant="caption" color="text.secondary">
//                   Verified patient
//                 </Typography>
//                 {/* <CheckCircleIcon fontSize="inherit" color="primary" /> */}
//               </Stack>
//             )}
//           </Box>
//         </Stack>
//       </CardContent>

//     </Card>
//                        ))}

//     </>
//   );
// });

// export default ProductReview;






// pages/ProductReview.tsx (or wherever you want to use it)
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { 
  Avatar, 
  Box, 
  Card, 
  CardContent, 
  Rating, 
  Stack, 
  Typography, 
  CircularProgress, 
  Alert 
} from "@mui/material";
import http from "../../commonFunctions/httpClient";

interface ApiReview {
  id: string;
  review: string;
  rating: number;
  productId: string;
  ph_Product: any | null;
  customerId: string;
  customerProfile: any | null;
  createdAt: string;
  updatedAt: string;
}

interface Review {
  id: string;
  name: string;
  rating: number;
  text: string;
  daysAgo: number;
  verified: boolean;
  avatarUrl?: string;
}

const ProductReview: React.FC = () => {
  const params = useParams();
  
  // Extract productId from wildcard or id param (same logic as before)
  let productId = params.id;
  if (params['*']) {
    productId = params['*'].split('/').pop() || '';
  }

  console.log("🔥 ALL PARAMS:", params);
  console.log("🔥 EXTRACTED PRODUCT ID:", productId);

  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const transformApiReview = useCallback((apiReview: ApiReview): Review => {
    const createdDate = new Date(apiReview.createdAt);
    const daysAgo = Math.floor((Date.now() - createdDate.getTime()) / (1000 * 60 * 60 * 24));
    
    // Robust customer name handling
    let customerName = "Anonymous";
    if (apiReview.customerProfile?.name) {
      customerName = apiReview.customerProfile.name;
    } else if (apiReview.customerId) {
      customerName = `Customer ${apiReview.customerId.slice(-6).toUpperCase()}`;
    }
    
    return {
      id: apiReview.id,
      name: customerName,
      rating: apiReview.rating,
      text: apiReview.review || "No review text",
      daysAgo: Math.max(0, daysAgo),
      verified: !!apiReview.customerProfile?.verified || false,
      avatarUrl: apiReview.customerProfile?.avatarUrl || undefined,
    };
  }, []);

  useEffect(() => {
    if (!productId) {
      setError("Product ID is required");
      setLoading(false);
      return;
    }

    const fetchReviews = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log("📡 Fetching reviews for product:", productId);
        const response = await http.get<ApiReview[]>(`pharmacy/products/GetReviews/${productId}`);
        
        console.log("📦 Reviews RESPONSE:", response);
        console.log("the response is ",response)
        
        if (response && Array.isArray(response)) {
          const transformedReviews = response.map(transformApiReview);
          setReviews(transformedReviews);
        } else {
          setReviews([]);
        }
      } catch (err: any) {
        console.error("💥 Reviews ERROR:", err);
        setError(err?.message || "Failed to fetch reviews");
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [productId, transformApiReview]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {error}
      </Alert>
    );
  }

  return (
    <>
      {reviews.length === 0 ? (
        <Typography variant="body1" color="text.secondary" textAlign="center" p={4}>
          No reviews yet.
        </Typography>
      ) : (
        reviews.map((review) => (
          <Card key={review.id} variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              {/* Rating & timestamp */}
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Rating value={review.rating} precision={0.5} readOnly size="small" />
                <Typography variant="caption" color="text.secondary">
                  {review.daysAgo} days ago
                </Typography>
              </Stack>

              {/* Review text */}
              <Typography variant="body2" mt={1} color="text.primary">
                {review.text}
              </Typography>

              {/* Author */}
              <Stack direction="row" spacing={2} mt={3} alignItems="center">
                <Avatar 
                  src={review.avatarUrl} 
                  alt={review.name} 
                  sx={{ width: 48, height: 48 }}
                >
                  {review.name.charAt(0).toUpperCase()}
                </Avatar>

                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    {review.name}
                  </Typography>

                  {review.verified && (
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <Typography variant="caption" color="text.secondary">
                        Verified patient
                      </Typography>
                    </Stack>
                  )}
                </Box>
              </Stack>
            </CardContent>
          </Card>
        ))
      )}
    </>
  );
};

export default React.memo(ProductReview);
